import cartTooltip from '../cart/rbmc.cart-tooltip';
import urlUtils from '../utils/rbmc.url-utils';
import cartCounter from '../header/rbmc.cart-counter';
import consumerEvents from '../events/rbmc.events.consumer-events';
import cartTracking from '../tracking/rbmc.tracking.cart';
import logger from '../utils/rbmc.logger';

const cartData = {
    init() {
        $(document).on('click', '.cart-tooltip__delete-link',
                cartData.removeMiniCartItem
        );
        this.errorCheck();
    },

    refreshCartTooltip(callback = null) {
        $.ajax({
            url:    `${urlUtils.getBaseUrl()}cart/fragment/`,
            method: 'GET',
            cache:  false
        }).done((response) => {

            $('#cart-tooltip').find('.custom-tooltip-body').replaceWith(
                    $(response).find('.custom-tooltip-body')
            );
            cartTooltip.cartIcon = cartTooltip.pageBody.find('.page-header__cart-trigger');
            cartTooltip.cart     = cartTooltip.pageBody.find('#cart-tooltip');

            if (callback != null) {
                callback();
            }
        });
    },

    removeMiniCartItem() {
        let $this = $(this);
        $this.parents('.cart-tooltip__item').animate({opacity: 0.4}, 1000);
        $.post(`${urlUtils.getBaseUrl()}cart/removeCartItem/${$this.data('entry-number')}`)
         .done(function (data) {
             if (data.success) {
                 cartData.refreshCartTooltip();
                 cartCounter.updateCounter(data.cartData.totalUnitCount);
                 //track consumer event
                 consumerEvents.trackRemoveFromCartEvent(data.trackingProductData);
                 //track GTM dataLayer
                 cartTracking.removeFromCart(data.gtmProductData, data.gtmProductData.quantity);
                 logger.log('Success deleting item');
             } else {
                 logger.error('Failed to delete item');
             }
         })
    },

    errorCheck() {
        const url = new URL(window.location.href);
        const error = url.searchParams.get("stockerror");
        const entry = url.searchParams.get("entry");
        if(url) {
            $(`.cart-entries-message--error[data-entry=${entry}]`).removeClass('d-none');
        }
    }
};

$(() => {
    cartData.init();
});

export default cartData;
